import { createAsyncThunk } from '@reduxjs/toolkit';
import axios, { type RawAxiosRequestHeaders } from 'axios';
import { RootState } from '../../app/store';

// error
import checkApiError from './checkApiError';
// set
import { setErrorMessages, resetErrorMessages } from '../errorReducer';

// ユーザ情報削除
type DeleteAccount = {
  jisTid?:string|null,
}
export const deleteAccountAsync = createAsyncThunk<boolean, DeleteAccount, { state: RootState }>('auth/deleteAccountAsync', async (params, thunkApi) => {
  const { dispatch } = thunkApi;
  const state = thunkApi.getState();
  const domain = process.env.REACT_APP_API_DOMAIN;
  // サーバーエラーを消す
  dispatch(resetErrorMessages());

  const headers: RawAxiosRequestHeaders = {
    accept: 'application/json',
    'jis-tid': state.user.account.jisTid,
    'cf-api-token': state.user.token,
  };

  try {
    const { jisTid } = params;
    const response = await axios.delete(`${domain}/userAccount`, {
      headers,
      data: {
        userAccount: {
          jisTid: jisTid ?? state.user.account.jisTid,
        },
      },
    });

    // JSONデータからエラーかどうか判断する
    const error = checkApiError(response);
    if (error) {
      dispatch(setErrorMessages(error));
      return false;
    }

    return true;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const errorData = error.response.data;
      // eslint-disable-next-line no-alert
      alert(errorData);
      throw new Error(errorData);
    }
  }
  return false;
});
export default deleteAccountAsync;
